<template>
  <v-card
    outlined
    class="px-6 pt-6 pb-3"
  >
    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
      <label class="subtitle-1 d-block grey--text">Matches</label>
      <b
        @click="addMatch"
        class="text-caption font-weight-bold header-btns"
      >Add Match</b>
    </div>
    <v-row
      v-for="(match, i) in matchListener"
      :key="i"
    >
      <v-col
        md="10"
        class="match-row"
      >
        <v-text-field
          outlined
          label="Match ID"
          hint="sample Match ID - MLB_2020_5_OAK_LAA"
          v-model="matchListener[i].match_id"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-left"
      >
        <v-icon
          @click="removeMatch(i)"
          class="text-caption font-weight-bold header-btns remove-icon"
        >mdi-close</v-icon>
      </v-col>
    </v-row>

  </v-card>
</template>
<script>

export default {
  props: {
    article_matches: {
      type: Array,
      default: function () { return [] }
    }
  },
  methods: {
    addMatch () {
      this.article_matches.push({
        match_id: ''
      })
    },

    removeMatch (i) {
      this.article_matches.splice(i, 1)
    }
  },

  computed: {
    matchListener: {
      get () {
        return this.article_matches
      },
      set (val) {
        this.$emit('update:article_matches', val)
      }
    }
  }
}
</script>
<style scoped>
.match-row {
  padding: 0 !important;
}
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.remove-icon {
  font-size: 20px !important;
}
</style>
